import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import { OutletDistributorForm, OutletDistributorRow, OutletRouteForm, OutletRouteRow, SalesSource } from '../types';
import { SalesSourceTable } from './sales-source-table';
import { OutletDistributorsTable } from './outlet-distributors-table';
import { OutletRoutesTable } from './outlet-routes-table';

type OutletRelationsTabsProps = {
  outletId?: number;
  salesSources: EntityBase[];
  outletSalesSources: SalesSource[];
  isLoadingSalesSources: boolean;
  onAddSalesSource: (salesSource: SalesSource) => void;
  onRemoveSalesSource: (index: number) => void;
  onUpdateSalesSource: (index: number, salesSource: SalesSource) => void;
  distributors: OutletDistributorRow[];
  isLoadingDistributors: boolean;
  onAddOutletDistributor: (item: OutletDistributorForm) => Promise<boolean>;
  onUpdateOutletDistributor: (distributorId: number, item: OutletDistributorForm) => Promise<boolean>;
  routes: OutletRouteRow[];
  isLoadingRoutes: boolean;
  onAddOutletRoute: (item: OutletRouteForm) => Promise<boolean>;
  onUpdateOutletRoute: (routeNumberId: number, item: OutletRouteForm) => Promise<boolean>;
  onRemoveOutletRoute: (routeNumberId: number) => Promise<boolean>;
  readOnly?: boolean;
};

export const OutletRelationsTabs = ({
  outletId,
  salesSources,
  outletSalesSources,
  isLoadingSalesSources,
  onAddSalesSource,
  onRemoveSalesSource,
  onUpdateSalesSource,
  distributors,
  isLoadingDistributors,
  onAddOutletDistributor,
  onUpdateOutletDistributor,
  routes,
  isLoadingRoutes,
  onAddOutletRoute,
  onUpdateOutletRoute,
  onRemoveOutletRoute,
  readOnly = false,
}: OutletRelationsTabsProps) => (
  <Tabs isLazy>
    <TabList>
      <Tab>Источники продаж ({outletSalesSources.length})</Tab>
      <Tab>Дистрибьюторы ({distributors.length})</Tab>
      <Tab>Маршруты ({routes.length})</Tab>
    </TabList>
    <TabPanels>
      <TabPanel px={0}>
        <SalesSourceTable
          outlet_id={outletId}
          salesSources={salesSources}
          outletSalesSources={outletSalesSources}
          isLoading={isLoadingSalesSources}
          onAddSalesSource={onAddSalesSource}
          onRemoveSalesSource={onRemoveSalesSource}
          onUpdateSalesSource={onUpdateSalesSource}
          readOnly={readOnly}
        />
      </TabPanel>
      <TabPanel px={0}>
        <OutletDistributorsTable
          distributors={distributors}
          isLoading={isLoadingDistributors}
          onAddOutletDistributor={onAddOutletDistributor}
          onUpdateOutletDistributor={onUpdateOutletDistributor}
          readOnly={readOnly}
        />
      </TabPanel>
      <TabPanel px={0}>
        <OutletRoutesTable
          routes={routes}
          isLoading={isLoadingRoutes}
          onAddOutletRoute={onAddOutletRoute}
          onUpdateOutletRoute={onUpdateOutletRoute}
          onRemoveOutletRoute={onRemoveOutletRoute}
          readOnly={readOnly}
        />
      </TabPanel>
    </TabPanels>
  </Tabs>
);
